<div class="more-wrapper">
  <img src="assets/icons/more_vert.svg" alt="More" (click)="toggleMoreDropdown($event)">
</div>

<!--export dropdown-->
<div class="export-container">
  <div class="dropdown-content-container-export" *ngIf="_dropdownOpened()" appOutSideClick
    (outSideClick)="onOutsideClick()">
    <div class="dropdown-menu">
      <!-- View Customer Report Option -->
      <div class="dropdown-item" (click)="handleReportClick()">
        <div class="icon-container">
          <img src="assets/icons/view_customer_report.svg" alt="View Customer Report">
        </div>
        <div class="item-content">
          <div class="item-title">View Customer Report</div>
          <div class="item-description">Preview of 10 recent filtered conversations</div>
        </div>
      </div>

      <!-- Export Data Option -->
      <div class="dropdown-item" (click)="onDownload()">
        <div class="icon-container">
          <img src="assets/icons/export_data.svg" alt="Export Data">
        </div>
        <div class="item-content">
          <div class="item-title">Export Data</div>
          <div class="item-description">Download current data table as .csv file</div>
        </div>
      </div>
    </div>
  </div>
</div>
